/**
 * MPRO LAB wallet-first API base (api-gateway /ms/wallet-auth). Same-origin in dev/prod via Vite/Vercel proxy.
 * No separate users microservice; browser only talks to MPROLAB_API_URL-backed routes.
 */
export function getWalletAuthApiRootUrl(): string {
  const primary = import.meta.env.VITE_WALLET_AUTH_API_URL?.trim().replace(/\/+$/, '') ?? ''
  if (primary) return primary
  const legacy = import.meta.env.VITE_USERS_SERVICE_API_URL?.trim().replace(/\/+$/, '') ?? ''
  if (legacy) return legacy
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api/wallet-auth`
  }
  return '/api/wallet-auth'
}

/** @deprecated Use getWalletAuthApiRootUrl — kept for OAuth returnUrl strings */
export function getUsersServiceRootUrl(): string {
  return getWalletAuthApiRootUrl()
}

/** RTK fetchBaseQuery baseUrl (must end with / for relative paths like `me`). */
export function getUsersServiceBaseQueryUrl(): string {
  const root = getWalletAuthApiRootUrl()
  return root ? `${root}/` : '/'
}

/** Axios base for auth routes (signature/hash, v2/login, check/wallet, …). */
export function getUsersServiceAuthBaseUrl(): string {
  const root = getWalletAuthApiRootUrl()
  return root ? `${root}/auth` : ''
}

export function getFileUploadGetTokenBaseUrl(): string {
  const raw = import.meta.env.VITE_FILE_UPLOAD_SERVICE_API_URL?.trim()
  if (!raw) return ''
  const base = raw.replace(/\/+$/, '')
  return `${base}/resources/get-token`
}

let warnedMissingWalletAuth = false

export function warnIfUsersServiceMissing(): void {
  if (warnedMissingWalletAuth || getWalletAuthApiRootUrl()) return
  warnedMissingWalletAuth = true
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(
      '[mprolab] VITE_WALLET_AUTH_API_URL is not set. Wallet session login will fail. ' +
        'Set it in the monorepo root .env, e.g. http://localhost:3000/api/wallet-auth (Vite proxies to api-gateway /ms/wallet-auth).',
    )
  }
}
